module.exports = "<app-ag-table></app-ag-table>"